(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ 35376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Faq; }
});

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/landing/Container.jsx + 1 modules
var Container = __webpack_require__(94964);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/faq/Header.jsx

function Header() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "pb-12 pt-4 flex items-center justify-center",
    style: {
      backgroundColor: "#231C5E"
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "text-white",
      children: "How can we help you?"
    })
  });
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/faq/WhatsTheDifference.jsx




var WhatsTheDifference = function WhatsTheDifference() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: ["While your bank hypothecates your funds for a number of risky propositions, Data Mynt facilitates \u2018staking\u2019 of funds.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Some blockchain protocols allow participants to earn additional cryptocurrency by contributing to the network. These rewards can be earned in many different ways including staking, inflation, savings rates, etc. Data Mynt wants businesses to be able to benefit from these protocols. Data Mynt will facilitate participation in these networks and pass on the rewards to eligible businesses who have opted into this feature.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Data Mynt supports the growth of modern, global businesses with global financial solutions.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "No monthly fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "No minimum balance required"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Immediate settlement, payments and liquidity management"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Control over your payroll"
      })]
    }), "Meanwhile, business savings accounts offered by legacy banks:", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Up to 10 business days for international wire transfers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "$16 average fee to receive international wire transfers*"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "$49 average fee to send international wire transfers*"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "APY ranging from 0.10% to 0.60%**"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "https://www.mybanktracker.com/news/wire-transfer-fee-comparison-top-10-us-banks",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "text-primary",
        target: "_blank",
        rel: "noreferrer",
        children: "*Source"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "https://www.fastcapital360.com/blog/best-high-yield-business-savings-accounts/",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "text-primary",
        target: "_blank",
        rel: "noreferrer",
        children: "**Source"
      })
    })]
  });
};

/* harmony default export */ var faq_WhatsTheDifference = (WhatsTheDifference);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/faq/HowToDeposit.jsx




function HowToDeposit() {
  var dmAppUrl =  true ? /(localhost)|(staging)/.test(window.location.hostname) ? "https://staging.datamynt.com" : "https://datamynt.com" : 0;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: ["Currently, Data Mynt deposits are handled through Moonpay, a trusted partner leader in digital assets payments worldwide. (We\u2019ll also be adding Banxa in a few weeks)", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Here\u2019s a step by step guide on how to deposit funds into your Data Mynt Global Business Wallet with Moonpay:", /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: ["Log in at", " ", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: dmAppUrl,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            rel: "noreferrer",
            children: "Data Mynt App"
          })
        }), ", add the amount you want to deposit into the deposit box, and click continue"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center question-image-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: "First step of deposit",
          width: 300,
          height: 170,
          src: "/depositFirstStep.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "You\u2019ll be asked for a verification code sent to your mail address. Enter the code and click continue."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "For the next step, you\u2019ll need to fill a form with your basic information. Fill the form and click continue"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center question-image-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 300,
          height: 400,
          alt: "Second step of deposit",
          src: "/depositSecondStep.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Next, you\u2019ll be asked to enter your billing address in order to process the deposit."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center question-image-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 300,
          height: 400,
          alt: "Third step of deposit",
          src: "/depositThirdStep.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Depending on your country\u2019s regulation you could be asked to verify your phone number in order to continue with the process."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center question-image-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 300,
          height: 400,
          alt: "Fourth step of deposit",
          src: "/depositFourthStep.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Next, you\u2019ll need to verify your identity. This process consists of only 4 to 5 steps and is optimized to approve your verification almost instantly after the requirements are sent."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "The first step consists of selecting the type of document you\u2019ll upload in order to verify your identity and the country of issuance."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center question-image-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 300,
          height: 400,
          alt: "Fifth step of deposit",
          src: "/depositFifthStep.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "The final process of identity verification needs to be completed on your phone. In order to do this you have two options: scan the QR provided or receive a link via text message. Select your preferred method and continue on your phone."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center question-image-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 300,
          height: 400,
          alt: "Sixth step of deposit",
          src: "/depositSixthStep.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Upload the required photos of the document you\u2019ve selected and take a selfie to complete the verification process. If these steps are done right, you will receive the approval almost immediately."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center question-image-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 300,
          height: 400,
          alt: "Seventh step of deposit",
          src: "/depositSeventhStep.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Last but not least, add your payment method and confirm your deposit."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center question-image-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 300,
          height: 200,
          alt: "Eigth step of deposit",
          src: "/depositEigthStep.png"
        })
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./components/faq/IosAndAndroid.jsx




function IosAndAndroid() {
  var dmAppUrl =  true ? /(localhost)|(staging)/.test(window.location.hostname) ? "https://staging.datamynt.com" : "https://datamynt.com" : 0;
  return /*#__PURE__*/_jsxs("div", {
    children: ["Our iOS and Android apps are currently in development and we\u2019re planning to have them available before the end of 2022.", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), "Nevertheless, until our mobile apps are ready, you can add the Data Mynt app shortcut to your mobile device home screen directly from your phone browser. Here\u2019s the step-by-step guide:", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
      children: "Safari Browser (iOS)"
    }), /*#__PURE__*/_jsxs("ul", {
      children: [/*#__PURE__*/_jsxs("li", {
        children: ["Navigate to the", " ", /*#__PURE__*/_jsx(Link, {
          href: dmAppUrl,
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            rel: "noreferrer",
            children: "Data Mynt app"
          })
        }), " ", "from your browser."]
      }), /*#__PURE__*/_jsx("li", {
        children: "Tap the square icon with an arrow pointing out of it at the bottom of your screen."
      }), /*#__PURE__*/_jsx("div", {
        className: "flex items-center justify-center my-4",
        children: /*#__PURE__*/_jsx(Image, {
          alt: "How to add an ios shortcut to your phone",
          width: 300,
          height: 110,
          src: "/appIconFirstStep.png"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: "Scroll down and tap \u201CAdd to Home Screen\u201D."
      }), /*#__PURE__*/_jsx("li", {
        children: "Accept the suggested name or enter a custom one."
      }), /*#__PURE__*/_jsx("li", {
        children: "Tap \u201CAdd\u201D & save the shortcut to the home screen."
      })]
    }), /*#__PURE__*/_jsx("b", {
      children: "Chrome Browser (Android)"
    }), /*#__PURE__*/_jsxs("ul", {
      children: [/*#__PURE__*/_jsxs("li", {
        children: ["Navigate to the", " ", /*#__PURE__*/_jsx(Link, {
          href: dmAppUrl,
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            rel: "noreferrer",
            children: "Data Mynt app"
          })
        }), " ", "from your Chrome browser."]
      }), /*#__PURE__*/_jsx("li", {
        children: "Tap the menu icon represented by 3 dots in the upper right corner of the browser app."
      }), /*#__PURE__*/_jsx("li", {
        children: "Tap \u201CAdd to Home Screen\u201D."
      }), /*#__PURE__*/_jsx("li", {
        children: "Enter a name for the shortcut or use the default one provided by Chrome."
      }), /*#__PURE__*/_jsx("li", {
        children: "Tap \u201CAdd\u201D & save the shortcut to the home screen."
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./components/faq/TwoFaOffer.jsx





var TwoFaOffer = function TwoFaOffer() {
  var dmAppUrl =  true ? /(localhost)|(staging)/.test(window.location.hostname) ? "https://staging.datamynt.com" : "https://datamynt.com" : 0;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: ["Yes! To enable 2FA on your account you need to go to your profile settings by clicking on your name at the top right corner of the page and selecting \u201Cprofile.\u201D You then will be redirected to your user panel. (Or just use", " ", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: dmAppUrl,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        children: "this link"
      })
    }), ").", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "There, select \u201Cenable/disable two-factor authentication\u201D after that you\u2019ll be asked to scan a QR with an authenticator app that will give the code you need to enter on Data Mynt to enable 2FA.", /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex items-center justify-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        width: 300,
        height: 170,
        alt: "Two factor authentication",
        src: "/twoFaFirstStep.png"
      })
    }), "If you don\u2019t have an authenticator app you can download Google Authenticator (", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        children: "Android"
      })
    }), "/", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "https://apps.apple.com/us/app/google-authenticator/id388497605",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        children: "iOS"
      })
    }), "), Authy (", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "https://play.google.com/store/apps/details?id=com.authy.authy",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        children: "Android"
      })
    }), "/", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "https://apps.apple.com/us/app/authy/id494168017",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        children: "iOS"
      })
    }), "), or Microsoft Authenticator (", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "https://play.google.com/store/apps/details?id=com.azure.authenticator",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        children: "Android"
      })
    }), "/", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "https://apps.apple.com/us/app/microsoft-authenticator/id983156458",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        children: "iOS"
      })
    }), ")."]
  });
};

/* harmony default export */ var faq_TwoFaOffer = (TwoFaOffer);
;// CONCATENATED MODULE: ./components/faq/ChangeEmail.jsx



function ChangeEmail() {
  var dmAppUrl =  true ? /(localhost)|(staging)/.test(window.location.hostname) ? "https://staging.datamynt.com/app" : "https://datamynt.com/app" : 0;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
    children: ["Yes! Go to your profile settings by clicking on your name at the top right corner of the page and selecting \u201Cprofile\u201D and you\u2019ll be redirected to your user panel or just use", " ", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: dmAppUrl,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        children: "this link"
      })
    }), ". There, select \u201CChange email address\u201D and follow the instructions."]
  });
}
;// CONCATENATED MODULE: ./components/faq/questionList.js





var QuestionList = [{
  question: "How do I get started with Data Mynt?",
  simpleAnswer: 'Download app from Apple App store or Google Play Store and Sign Up. Contact us via Whatsapp         <a style="color: blue" href="TEL:+1-510-493-7072">+1-510-493-7072</a>  or  email <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@ddatamynt.zendesk.com</a> for questions or support.'
}, {
  question: "How can I fund my Data Mynt wallet?",
  simpleAnswer: 'You can add funds to your account by depositing digital assets or mobile money or bank transfer in supported countries. To start this process, download app, reach out on DataMynt.com, contact us on Telegram or Whatsapp <a style="color: blue" href="TEL:+1-510-493-7072">+1-510-493-7072</a>,  (email <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@datamynt.zendesk.com</a>).'
}, {
  question: "How do I send payments?",
  simpleAnswer: "Tap ‘Send Payment’ then input amount, receiver details including blockchain wallet, and confirm blockchain plus crypto to send. Please ensure that you are sending the right cryptocurrency to the right wallet address (e.g., send only Bitcoin to a Bitcoin address; do not send ETH to a Bitcoin address or it will be lost forever)."
}, {
  question: "Withdraw?",
  simpleAnswer: 'Via Debit card from your DataMynt.com wallet or to initiate a Bank transfer email <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@datamynt.zendesk.com</a>.'
}, {
  question: "How do I get paid?",
  simpleAnswer: "After downloading the Data Mynt app and Signing Up for an account, simply open the Data Mynt app and tap the Get Paid icon. Next, choose the amount of the transaction you want to be paid. Choose the cryptocurrency your customer will be paying in (e.g., Bitcoin), and add the customer’s email address if they want to receive a receipt. Your Data Mynt app will generate a QR code to receive the payment - this QR code is connected to your Data Mynt wallet, and can only receive the cryptocurrency that you and your customer have chosen (in this example, Bitcoin). Show this QR code to the customer and ask them to send the payment with their preferred cryptocurrency wallet. Once they have sent the payment, tap Continue and wait for the confirmation of the payment."
}, {
  question: "What is Data Mynt?",
  simpleAnswer: "Data Mynt is the leading provider of blockchain base operational and financial infrastructure for businesses, including multi currency wallets, payment processing, payment gateway, point of sale and other offerings. asset checkout and payment processing. What that means is that we allow our users to accept payments from their customers or send to suppliers in the form of cryptocurrency, with those payments being automatically converted into a localized stablecoin. This creates an easy-to-use pipeline between whatever cryptocurrency the customer wants to pay in and the bank account of the merchant, allowing more customers to pay for more goods and services in better, more efficient and cheaper ways."
}, {
  question: "What’s the difference between a Data Mynt Global Business Wallet and a Business Savings Account from a bank?",
  structuredAnswer: faq_WhatsTheDifference
}, {
  question: "What is staking?",
  simpleAnswer: "Staking is the process of actively participating in transaction validation (similar to mining) on a proof-of-stake (PoS) blockchain. On these blockchains, anyone with a minimum-required balance of a specific cryptocurrency can validate transactions"
}, {
  question: "How does staking work?",
  simpleAnswer: "When the minimum balance is met, a node deposits that amount of cryptocurrency into the network as a stake (similar to a security deposit).<br/>The size of a stake is directly proportional to the chances of that node being chosen to forge the next block.<br/>If the node successfully creates a block, the validator receives a reward, similar to how a miner is rewarded in proof-of-work chains.<br/>Validators lose part of their stake if they double-sign or attempt to attack the network."
}, {
  question: "What is inflation?",
  simpleAnswer: "Assets such as Algorand (ALGO) earn rewards via inflation, or community rewards. With inflation, new tokens are added to the network at a rate determined by the protocol, and those tokens are then distributed to holders as rewards."
}, {
  question: "Who is the team behind Data Mynt?",
  simpleAnswer: ' See page here <a style="color: blue" href=" https://datamynt.com/aboutus">Here </a>'
}, {
  question: "How can I deposit funds into my Data Mynt Global Business Wallet?",
  structuredAnswer: HowToDeposit
}, {
  question: "What is the minimum balance required for a Data Mynt Business Wallet?",
  simpleAnswer: "There are no minimum balances required to have a Data Mynt Wallet"
}, {
  question: "If I have a problem with a deposit or withdrawal, what should I do?",
  simpleAnswer: 'Contact us immediately at <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@datamynt.zendesk.com</a> to resolve the issue.'
}, {
  question: "What are the deposit fees?",
  simpleAnswer: "<b>No deposit fees.</b>"
}, {
  question: "What are the withdrawal fees?",
  simpleAnswer: "<b>No withdrawal fees.</b>"
}, {
  question: "What States are not yet supported by Data Mynt?",
  simpleAnswer: "Hawaii, New York, Rhode Island."
}, {
  question: "How long do I have to leave the funds in my Data Mynt Business Wallet before I can withdraw them?",
  simpleAnswer: "You can withdraw your money whenever you want; you are always in control of your funds at Data Mynt."
}, {
  question: "Are Data Mynt Business Wallets covered by the FDIC?",
  simpleAnswer: "Data Mynt Wallets are not covered by the Federal Deposit Insurance Corporation."
}, {
  question: "How much does a Data Mynt account cost for me to use? ",
  simpleAnswer: "Data Mynt is charges 1% to accept payments and 0.5% to send. "
}, {
  question: "What Stablecoins are supported by Data Mynt?",
  simpleAnswer: "Data Mynt currently supports the following stablecoins: USDC, Tether, EURO Coin, and DAI."
}, {
  question: "Are there iOS and Android Apps available for Data Mynt?",
  simpleAnswer: "Absolutely! You can download the Data Mynt app from the Apple App Store, or the Google Play Store."
}, {
  question: "Does Data Mynt offer 2FA (Two-Factor Authentication) to secure my account?",
  structuredAnswer: faq_TwoFaOffer
}, {
  question: "Can I change the email address for my account?",
  structuredAnswer: ChangeEmail
}, {
  question: "Does my customer need to have a Data Mynt account in order to pay me?",
  simpleAnswer: "Not at all! Your shopper can pay you using their preferred cryptocurrency wallet; you will need to simply enter the blockchain and cryptocurrency preferred and show them a unique QR code for them to scan with their wallet app and pay you."
}, {
  question: "What if I have Performance Issues in the app?",
  simpleAnswer: 'If you find any performance issues in our platform and/or have any suggestions, please share them with us at <a style="color: blue" href="mailto:support@datamynt.zendesk.com">support@datamynt.zendesk.com</a>.'
}, {
  question: "Are you Hiring?",
  simpleAnswer: 'Yes! We’re actively looking for talented people who want to join us in building the future of financial services. Take a look at our open positions here: <a style="color: blue" href="https://angel.co/company/defi4all/jobs">https://angel.co/company/defi4all/jobs</a>.'
}];
/* harmony default export */ var questionList = (QuestionList);
;// CONCATENATED MODULE: ./components/faq/QuestionPill.jsx




var QuestionPill = function QuestionPill(_ref) {
  var item = _ref.item,
      index = _ref.index,
      expandedPill = _ref.expandedPill,
      setPillAsExpanded = _ref.setPillAsExpanded;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    onClick: function onClick() {
      return expandedPill !== index ? setPillAsExpanded(index) : setPillAsExpanded(-1);
    },
    className: "flex flex-col space-y-6 w-full md:w-3/5 cursor-pointer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "p-8 space-y-4",
      style: {
        boxShadow: "0px 5px 25px rgba(42, 52, 61, 0.08)",
        borderRadius: "6px"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between items-center space-x-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "flex-grow font-bold",
          children: item.question
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex-shrink-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            alt: "Expand and contract",
            height: "24",
            width: "24",
            src: expandedPill === index ? "/contract.svg" : "/expand.svg"
          })
        })]
      }), item.simpleAnswer ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat(expandedPill === index ? "" : "hidden"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          dangerouslySetInnerHTML: {
            __html: item.simpleAnswer
          }
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat(expandedPill === index ? "" : "hidden"),
        children: item.structuredAnswer()
      })]
    })
  }, item.id);
};

/* harmony default export */ var faq_QuestionPill = (QuestionPill);
;// CONCATENATED MODULE: ./components/faq/QuestionsAndAnswers.jsx




function QuestionsAndAnswers() {
  var _useState = (0,react.useState)(-1),
      expandedPill = _useState[0],
      setExpandedPill = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "flex flex-col items-center p-12 space-y-6",
    children: questionList.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(faq_QuestionPill, {
          item: item,
          index: index,
          expandedPill: expandedPill,
          setPillAsExpanded: setExpandedPill
        })
      }, item.question);
    })
  });
}
;// CONCATENATED MODULE: ./pages/faq.jsx








function Faq() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Data\xA0Mynt: Be Your Own Bank"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Generated by create next app"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: "/favicon/favicon-32x32.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: "/favicon/favicon-16x16.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "manifest",
        href: "/favicon/site.webmanifest"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "mask-icon",
        href: "/favicon/safari-pinned-tab.svg",
        color: "#5bbad5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "msapplication-TileColor",
        content: "#2b5797"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "theme-color",
        content: "#ffffff"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: "/favicon/apple-icon-57x57.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "60x60",
        href: "/favicon/apple-icon-60x60.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: "/favicon/apple-icon-72x72.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: "/favicon/apple-icon-76x76.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: "/favicon/apple-icon-114x114.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: "/favicon/apple-icon-120x120.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: "/favicon/apple-icon-144x144.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: "/favicon/apple-icon-152x152.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: "/favicon/apple-icon-180x180.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "192x192",
        href: "/favicon/android-icon-192x192.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: "/favicon/favicon-32x32.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "96x96",
        href: "/favicon/favicon-96x96.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: "/favicon/favicon-16x16.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "manifest",
        href: "/favicon/manifest.json"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "msapplication-TileColor",
        content: "#ffffff"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "msapplication-TileImage",
        content: "/ms-icon-144x144.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "theme-color",
        content: "#ffffff"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        background: "white"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionsAndAnswers, {})]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      src: "https://www.googleoptimize.com/optimize.js?id=OPT-WWVFB9W"
    })]
  });
}

/***/ }),

/***/ 78192:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(35376);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,5675,6770,9530,4964,9774,2888,179], function() { return __webpack_exec__(78192); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);